/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventQuestionStatus } from './EventQuestionStatus';
import {
    EventQuestionStatusFromJSON,
    EventQuestionStatusFromJSONTyped,
    EventQuestionStatusToJSON,
    EventQuestionStatusToJSONTyped,
} from './EventQuestionStatus';

/**
 * The asker's view of their own question.
 * @export
 * @interface EventQuestionOwnRead
 */
export interface EventQuestionOwnRead {
    /**
     * 
     * @type {string}
     * @memberof EventQuestionOwnRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventQuestionOwnRead
     */
    text: string;
    /**
     * 
     * @type {EventQuestionStatus}
     * @memberof EventQuestionOwnRead
     */
    status: EventQuestionStatus;
    /**
     * 
     * @type {string}
     * @memberof EventQuestionOwnRead
     */
    answer_text?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EventQuestionOwnRead
     */
    answered_at?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EventQuestionOwnRead
     */
    published_at?: Date | null;
}



/**
 * Check if a given object implements the EventQuestionOwnRead interface.
 */
export function instanceOfEventQuestionOwnRead(value: object): value is EventQuestionOwnRead {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function EventQuestionOwnReadFromJSON(json: any): EventQuestionOwnRead {
    return EventQuestionOwnReadFromJSONTyped(json, false);
}

export function EventQuestionOwnReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventQuestionOwnRead {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'text': json['text'],
        'status': EventQuestionStatusFromJSON(json['status']),
        'answer_text': json['answer_text'] == null ? undefined : json['answer_text'],
        'answered_at': json['answered_at'] == null ? undefined : (new Date(json['answered_at'])),
        'published_at': json['published_at'] == null ? undefined : (new Date(json['published_at'])),
    };
}

export function EventQuestionOwnReadToJSON(json: any): EventQuestionOwnRead {
    return EventQuestionOwnReadToJSONTyped(json, false);
}

export function EventQuestionOwnReadToJSONTyped(value?: EventQuestionOwnRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'text': value['text'],
        'status': EventQuestionStatusToJSON(value['status']),
        'answer_text': value['answer_text'],
        'answered_at': value['answered_at'] == null ? undefined : ((value['answered_at'] as any).toISOString()),
        'published_at': value['published_at'] == null ? undefined : ((value['published_at'] as any).toISOString()),
    };
}

